export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-10_00.6e3115ce.jpg";